<!-- 
    计费设置组件
    接受参数： 机房状态status:{}、供冷供热设置条件：form:{},计费模式选择
    保存按钮
 -->
<template>
    <div>
        <div>
            <div class="container-title">当前空调机房状态</div>
            <el-form :model="status" label-width="100px" class="ruleForm">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="水流速状态">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="计费状态">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="通讯状态">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="回水温度">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="供水温度">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="传感器温度">
                            <el-input v-model="status.name" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <el-form :model="formData" ref="formData" :rules="formRules" label-width="110px" class="ruleForm">
        <div>
            <el-row :gutter="40">
                <el-col :span="10">
                    <div class="container-title">供冷设置</div>
                    <div style="width:70%;">
                        <el-form-item label="供水温度 <=" prop="supply_temp_cool">
                            <el-input v-model.number="formData.supply_temp_cool" >
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="回水温度 <=" prop="back_temp_cool">
                            <el-input v-model.number="formData.back_temp_cool">
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="计费条件 <=" prop="allow_temp_cool">
                            <el-input v-model.number="formData.allow_temp_cool">
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="container-title">供热设置</div>
                    <div style="width:70%;">
                        <el-form-item label="供水温度 >=" prop="supply_temp_hot">
                            <el-input v-model.number="formData.supply_temp_hot">
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="回水温度 >=" prop="back_temp_hot">
                            <el-input v-model.number="formData.back_temp_hot">
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="计费条件 >=" prop="allow_temp_hot">
                            <el-input v-model.number="formData.allow_temp_hot">
                                <span slot="suffix">℃</span>
                            </el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-form-item label="计费标准：" prop="is_supply_or_back">
                <el-radio v-model="formData.is_supply_or_back" :label="1">供水温度</el-radio>
                <el-radio v-model="formData.is_supply_or_back" :label="2">回水温度</el-radio>
            </el-form-item>
        </div>
       
        <div style="margin-bottom: 20px;line-height: 40px;">
            <!-- <span class="schema-title">计费模式：</span>
            <el-radio v-model="formData.is_auto" :label="1">自动模式</el-radio>
            <el-radio v-model="formData.is_auto" :label="2">手动模式</el-radio>
            <el-select style="margin-left:20px;" v-if="formData.is_auto === 2" v-model="formData.manualchargingmode" placeholder="系统计费开关">
                <el-option label="开" :value="1"></el-option>
                <el-option label="关" :value="2"></el-option>
            </el-select> -->
            <br>
            <span class="schema-title">水流速设置：</span>
            <el-form-item label="水流速" style="display:inline-block;" label-width="65px" prop="water_velocity">
                <el-input v-model="formData.water_velocity" style="width:200px"></el-input>
            </el-form-item>
        </div>
        </el-form>
        <div style="text-align:center;">
            <el-button type="primary" style="width:150px;" @click="onSave">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cmpcharge',
    props: ["form"],
    data () {
        return {
            formData: {
                is_supply_or_back: 2,    //  以供水或回水为标准（0默认，1供水，2回水）
                // 供冷设置
                supply_temp_cool: '',    //  供水温度（冷）
                back_temp_cool: '',    //  回水温度（冷）
                allow_temp_cool: '',    //  计费条件（冷）
                // 供热设置
                supply_temp_hot: '',    //  供水温度（热）
                back_temp_hot: '',    //  回水温度（热）
                allow_temp_hot: '',    //  计费条件（热）
                
                // 计费模式
                is_auto: 1,    //  是否自动计费（0默认，1自动计费，2手动计费）
                manualchargingmode: '',   //  计费开关（0默认，1开，2关

                water_velocity: '',
                summer_cool_date_start: '',
                summer_cool_date_end: '',
                winter_hot_date_start: '',
                winter_hot_date_end: '',

                winter_hot_date: [],
                summer_cool_date: [],

            },
            formRules: {
                supply_temp_cool: [{ required: true, message: '供水温度', trigger: 'blur' },
                                    { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                back_temp_cool: [{ required: true, message: '回水温度', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                allow_temp_cool: [{ required: true, message: '计费条件', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                supply_temp_hot: [{ required: true, message: '供水温度', trigger: 'blur' },
                                    { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                back_temp_hot: [{ required: true, message: '回水温度', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                allow_temp_hot: [{ required: true, message: '计费条件', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                is_auto: [{ required: true, message: '计费模式', trigger: 'blur' },],
                water_velocity: [{ required: true, message: '请输入水流速', trigger: 'blur' },],
                // summer_cool_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                // winter_hot_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
            },
            status: {
                name: '',
            }, //  空调机房参数
        };
    },
    created() {
        if(this.form.oid){
            this.initData(this.form);
        }
    },
    watch: {
        form(val){
            this.initData(val);
        }
    },
    methods: {
        // 保存
        onSave() {
            if(this.formData.is_auto == 2) {
                // 手动模式
                this.$emit('onSave', this.formData)
            }else{
                // 自动模式
                this.$refs['formData'].validate((valid)=>{
                    if(valid) {
                        this.$emit('onSave', this.formData)
                    }else{
                        return false
                    }
                })
            }
        },
        choseTime(val) {
            if(val) {
                this.formData.summer_cool_date_start = val[0]
                this.formData.summer_cool_date_end = val[1]
            }else{
                this.formData.summer_cool_date_start = ''
                this.formData.summer_cool_date_end = ''
            }
        },
        choseTime2(val) {
            if(val) {
                this.formData.winter_hot_date_start = val[0]
                this.formData.winter_hot_date_end = val[1]
            }else{
                this.formData.winter_hot_date_start = ''
                this.formData.winter_hot_date_end = ''
            }
        },
        // 处理默认值
        initData(data){
            let {
                oid,
                is_supply_or_back, 
                supply_temp_cool,
                back_temp_cool,
                allow_temp_cool, 
                supply_temp_hot,
                back_temp_hot,
                allow_temp_hot,
                is_auto,
                manualchargingmode,
                // SummerCoolDateStart,
                // SummerCoolDateEnd,
                // WinterHotDateStart,
                // WinterHotDateEnd,
                water_velocity
            } = data;
            
            this.formData.oid = oid;
            this.formData.is_supply_or_back= is_supply_or_back;
            this.formData.supply_temp_cool= supply_temp_cool === 0 ? '' : supply_temp_cool;   
            this.formData.back_temp_cool= back_temp_cool === 0 ? '' : back_temp_cool;   
            this.formData.allow_temp_cool= allow_temp_cool === 0 ? '' : allow_temp_cool;
            this.formData.supply_temp_hot= supply_temp_hot === 0 ? '' : supply_temp_hot;
            this.formData.back_temp_hot= back_temp_hot === 0 ? '' : back_temp_hot;
            this.formData.allow_temp_hot= allow_temp_hot === 0 ? '' : allow_temp_hot;
            this.formData.is_auto = is_auto === 0 ? 1 : is_auto;
            this.formData.manualchargingmode= manualchargingmode === 0 ? '' : manualchargingmode;
            // this.formData.summer_cool_date_start= SummerCoolDateStart;
            // this.formData.summer_cool_date_end= SummerCoolDateEnd;
            // this.formData.winter_hot_date_start= WinterHotDateStart;
            // this.formData.winter_hot_date_end= WinterHotDateEnd; 
            this.formData.water_velocity= water_velocity; 

            // this.formData.summer_cool_date = [SummerCoolDateStart, SummerCoolDateEnd]
            // this.formData.winter_hot_date = [WinterHotDateStart, WinterHotDateEnd]
        }
    },

}

</script>
<style lang='less' scoped>
    .container-title{
        margin-top: 0;
    }
    .schema-title{
        font-size: 18px;
        color: #1f2f3d;
        margin-right: 10px;
    }
</style>